<button [class.active]="selected | async" (click)="click()">
  <div truncate class="label">
    <ng-content></ng-content>
    <span class="rv-right count" *ngIf="count != null">{{ count }}</span>
  </div>
</button>
